import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiver = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 19 13",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M4.043 9.312c-.155.01-.298.03-.432.056-.209.464-.116 1.062-.708 1.364-.32.17-.612-.087-.744-.372-.252.44-.315.912-.347 1.183-.031.256-.048.432-.033.54a.65.65 0 0 0 .197-.068c.31-.154.63-.52.879-.85.486-.643 2.346-1.282 3.479-2.638-.494.37-1.239.714-2.291.785Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m3.217 9.698.077-.282a2.314 2.314 0 0 0-.546.215c-.18.1-.336.225-.468.373a.396.396 0 0 0 .032.098c.062.174.223.33.347.33a.208.208 0 0 0 .09-.023l.003-.002c.322-.148.385-.396.465-.709Zm14.891-7.883c-.12-.512-.423-.736-2.682-1.117-2.23-.376-5.043-.07-6.002.337a.3.3 0 0 0-.036.016c-1.81.777-2.72 4.26-2.1 6.39a.917.917 0 0 0 .066.128c.413.666 1.648.689 3.38-.588 1.69-1.262 3.232-1.62 4.45-2.997 1.541-1.744 3.043-1.656 2.924-2.169Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M.264 3.889c-.798 2.997.44 4.569.714 6.76.107.848.322 1.217.58 1.306-.07-.144-.018-.43.023-.702.07-.582.332-2.104 2.268-2.235 1.809-.122 2.702-1.058 2.972-1.54l.032-.071c-.39-.6-.677-1.996.002-3.918.711-2.014 1.728-2.409 2.139-2.417C6.657-.094 1.748-.573.264 3.889Z"
		})
	]
});
export default SvgLiver;
